import React, { useEffect, useState } from 'react';
import Overlay from './components/fidenza/Overlay';
import GameReward from './pages/GameReward';
import Passport from './pages/Passport';
import InstructionsVillageInfo from './pages/VillageInfo';
import Instructions from './pages/fidenza/Instructions';
import FidenzaServices from './pages/fidenza/Services';
import FidenzaShoppingExpress from './pages/fidenza/ShoppingExpress';
import FidenzaAttractions from './pages/fidenza/LocalAttractions';
import ArtGallery from './pages/fidenza/gallery/ArtGallery';
import ArtFestival from './pages/fidenza/gallery/ArtFestival';
import ArtOne from './pages/fidenza/gallery/ArtOne';
import ArtTwo from './pages/fidenza/gallery/ArtTwo';
import ArtThree from './pages/fidenza/gallery/ArtThree';
import ArtFour from './pages/fidenza/gallery/ArtFour';
import FidenzaMember from './pages/fidenza/Member';
import FidenzaSfh from './pages/fidenza/ShopFromHome';
import DownloadApp from './pages/fidenza/DownloadApp';
import Signorvino from './pages/fidenza/restaurants/Signorvino';
import Bollicine from './pages/fidenza/restaurants/Bollicine';
import Capuccino from './pages/fidenza/restaurants/Capuccino';
import FlowerBurger from './pages/fidenza/restaurants/FlowerBurger';
import KoiShushi from './pages/fidenza/restaurants/KoiShushi';
import ParmaMenu from './pages/fidenza/restaurants/ParmaMenu';
import Venchi from './pages/fidenza/restaurants/Venchi';
import PersonalShopping from './pages/fidenza/apartment/PersonalShopping';
import ShopAndEarn from './pages/fidenza/apartment/ShopAndEarn';
import HandsFreeShopping from './pages/fidenza/apartment/HandsFreeShopping';
import ApartmentWelcome from './pages/fidenza/apartment/Welcome';
import ApartmentServices from './pages/fidenza/apartment/Services';
import { disptchCTAClickObject } from './Analytics';
import VeroLatte from './pages/fidenza/restaurants/VeroLatte';

const villageName = 'fidenza';

function FidenzaApp() {
  const [activeScene, setActiveScene] = useState('room-1');
  const [instructionsActive, setInstructionsActive] = useState(false);
  const [villageInfoActive, setVillageInfoActive] = useState(false);
  const [passportActive, setPassportActive] = useState(false);
  const [gameRewardActive, setGameRewardActive] = useState(false);
  const [shoppingExpressActive, setShoppingExpressActive] = useState(false);
  const [attractionsActive, setAttractionsActive] = useState(false);
  const [artGalleryActive, setArtGalleryActive] = useState(false);
  const [artFestivalActive, setArtFestivalActive] = useState(false);
  const [artOneActive, setArtOneActive] = useState(false);
  const [artTwoActive, setArtTwoActive] = useState(false);
  const [artThreeActive, setArtThreeActive] = useState(false);
  const [artFourActive, setArtFourActive] = useState(false);
  const [memberActive, setMemberActive] = useState(false);
  const [personalShoppingActive, setPersonalShoppingActive] = useState(false);
  const [sfhActive, setSfhActive] = useState(false);
  const [apartmentWelcomeActive, setApartmentWelcomeActive] = useState(false);
  const [apartmentServicesActive, setApartmentServicesActive] = useState(false);
  const [servicesActive, setServicesActive] = useState(false);
  const [downloadAppActive, setDownloadAppActive] = useState(false);
  const [signoActive, setSignoActive] = useState(false);
  const [bollicineActive, setBollicineActive] = useState(false);
  const [capuccinoActive, setCapuccinoActive] = useState(false);
  const [flowerBurgerActive, setFlowerBurgerActive] = useState(false);
  const [koiShushiActive, setKoiShushiActive] = useState(false);
  const [parmaMenuActive, setParmaMenuActive] = useState(false);
  const [venchiActive, setVenchiActive] = useState(false);
  const [veroLatteActive, setVeroLatteActive] = useState(false);
  const [shopEarnActive, setShopEarnActive] = useState(false);
  const [hfsActive, setHfsActive] = useState(false);

  const openVillageInfo = () => {
    setVillageInfoActive(true);
  };

  const closeInstructions = () => {
    disptchCTAClickObject('fidenza', 'Button', 'Instructions', 'Close', '');
    setInstructionsActive(false);
    setVillageInfoActive(true);
  };

  const openPassport = () => {
    disptchCTAClickObject('fidenza', 'Button', 'Passport', 'Open', '');
    setPassportActive(true);
  };

  const closePassport = () => {
    disptchCTAClickObject('fidenza', 'Button', 'Passport', 'Close', '');
    setPassportActive(false);
  };

  const updateActiveScene = (sceneName: string) => {
    if (activeScene !== sceneName) {
      setActiveScene(sceneName);
      window.changeUrls();
    }
  };

  const openGameReward = () => {
    disptchCTAClickObject('fidenza', 'Button', 'GameReward', 'Open', '');
    setGameRewardActive(true);
  };

  const closeGameReward = () => {
    disptchCTAClickObject('fidenza', 'Button', 'GameReward', 'Close', '');
    setGameRewardActive(false);
  };

  const openFidenzaShoppingExpress = () => {
    disptchCTAClickObject('fidenza', 'Button', 'ShoppingExpress', 'Open', '');
    setShoppingExpressActive(true);
  };

  const closeFidenzaShoppingExpress = () => {
    disptchCTAClickObject('fidenza', 'Button', 'ShoppingExpress', 'Close', '');
    setShoppingExpressActive(false);
  };

  const openFidenzaAttractions = () => {
    disptchCTAClickObject('fidenza', 'Button', 'Attractions', 'Open', '');
    setAttractionsActive(true);
  };

  const closeFidenzaAttractions = () => {
    disptchCTAClickObject('fidenza', 'Button', 'Attractions', 'Close', '');
    setAttractionsActive(false);
  };

  const openArtGallery = () => {
    disptchCTAClickObject('fidenza', 'Button', 'ArtGallery', 'Open', '');
    setArtGalleryActive(true);
  };

  const closeArtGallery = () => {
    disptchCTAClickObject('fidenza', 'Button', 'ArtGallery', 'Close', '');
    setArtGalleryActive(false);
  };

  const openArtFestival = () => {
    disptchCTAClickObject('fidenza', 'Button', 'ArtFestival', 'Open', '');
    setArtFestivalActive(true);
  };

  const closeArtFestival = () => {
    disptchCTAClickObject('fidenza', 'Button', 'ArtFestival', 'Close', '');
    setArtFestivalActive(false);
  };

  const openArtOne = () => {
    disptchCTAClickObject('fidenza', 'Button', 'ArtOne', 'Open', '');
    setArtOneActive(true);
  };

  const closeArtOne = () => {
    disptchCTAClickObject('fidenza', 'Button', 'ArtOne', 'Close', '');
    setArtOneActive(false);
  };

  const openArtTwo = () => {
    disptchCTAClickObject('fidenza', 'Button', 'ArtTwo', 'Open', '');
    setArtTwoActive(true);
  };

  const closeArtTwo = () => {
    disptchCTAClickObject('fidenza', 'Button', 'ArtTwo', 'Close', '');
    setArtTwoActive(false);
  };

  const openArtThree = () => {
    disptchCTAClickObject('fidenza', 'Button', 'ArtThree', 'Open', '');
    setArtThreeActive(true);
  };

  const closeArtThree = () => {
    disptchCTAClickObject('fidenza', 'Button', 'ArtThree', 'Close', '');
    setArtThreeActive(false);
  };

  const openArtFour = () => {
    disptchCTAClickObject('fidenza', 'Button', 'ArtFour', 'Open', '');
    setArtFourActive(true);
  };

  const closeArtFour = () => {
    disptchCTAClickObject('fidenza', 'Button', 'ArtFour', 'Close', '');
    setArtFourActive(false);
  };

  const openFidenzaMember = () => {
    disptchCTAClickObject('fidenza', 'Button', 'Member', 'Open', '');
    setMemberActive(true);
  };

  const closeFidenzaMember = () => {
    disptchCTAClickObject('fidenza', 'Button', 'Member', 'Close', '');
    setMemberActive(false);
  };

  const openFidenzaPersonalShopping = () => {
    disptchCTAClickObject('fidenza', 'Button', 'PersonalShopping', 'Open', '');
    setPersonalShoppingActive(true);
  };

  const closeFidenzaPersonalShopping = () => {
    disptchCTAClickObject('fidenza', 'Button', 'PersonalShopping', 'Close', '');
    setPersonalShoppingActive(false);
  };

  const openFidenzaSfh = () => {
    disptchCTAClickObject('fidenza', 'Button', 'ShopFromHome', 'Open', '');
    setSfhActive(true);
  };

  const closeFidenzaSfh = () => {
    disptchCTAClickObject('fidenza', 'Button', 'ShopFromHome', 'Close', '');
    setSfhActive(false);
  };

  const openFidenzaApartmentWelcome = () => {
    disptchCTAClickObject('fidenza', 'Button', 'ApartmentWelcome', 'Open', '');
    setApartmentWelcomeActive(true);
  };

  const closeFidenzaApartmentWelcome = () => {
    disptchCTAClickObject('fidenza', 'Button', 'ApartmentWelcome', 'Close', '');
    setApartmentWelcomeActive(false);
  };

  const openFidenzaApartmentServices = () => {
    disptchCTAClickObject('fidenza', 'Button', 'ApartmentServices', 'Open', '');
    setApartmentServicesActive(true);
  };

  const closeFidenzaApartmentServices = () => {
    disptchCTAClickObject('fidenza', 'Button', 'ApartmentServices', 'Close', '');
    setApartmentServicesActive(false);
  };

  const openFidenzaServices = () => {
    disptchCTAClickObject('fidenza', 'Button', 'Services', 'Open', '');
    setServicesActive(true);
  };

  const closeFidenzaServices = () => {
    disptchCTAClickObject('fidenza', 'Button', 'Services', 'Close', '');
    setServicesActive(false);
  };

  const openDownloadApp = () => {
    disptchCTAClickObject('fidenza', 'Button', 'DownloadApp', 'Open', '');
    setDownloadAppActive(true);
  };

  const closeDownloadApp = () => {
    disptchCTAClickObject('fidenza', 'Button', 'DownloadApp', 'Close', '');
    setDownloadAppActive(false);
  };

  const openSignorvino = () => {
    disptchCTAClickObject('fidenza', 'Button', 'Signorvino', 'Open', '');
    setSignoActive(true);
  };

  const closeSignorvino = () => {
    disptchCTAClickObject('fidenza', 'Button', 'Signorvino', 'Close', '');
    setSignoActive(false);
  };

  const openBollicine = () => {
    disptchCTAClickObject('fidenza', 'Button', 'Bollicine', 'Open', '');
    setBollicineActive(true);
  };

  const closeBollicine = () => {
    disptchCTAClickObject('fidenza', 'Button', 'Bollicine', 'Close', '');
    setBollicineActive(false);
  };

  const openCappuccino = () => {
    disptchCTAClickObject('fidenza', 'Button', 'Cappuccino', 'Open', '');
    setCapuccinoActive(true);
  };

  const closeCappuccino = () => {
    disptchCTAClickObject('fidenza', 'Button', 'Cappuccino', 'Close', '');
    setCapuccinoActive(false);
  };

  const openFlowerBurger = () => {
    disptchCTAClickObject('fidenza', 'Button', 'FlowerBurger', 'Open', '');
    setFlowerBurgerActive(true);
  };

  const closeFlowerBurger = () => {
    disptchCTAClickObject('fidenza', 'Button', 'FlowerBurger', 'Close', '');
    setFlowerBurgerActive(false);
  };

  const openKoiShushi = () => {
    disptchCTAClickObject('fidenza', 'Button', 'KoiShushi', 'Open', '');
    setKoiShushiActive(true);
  };

  const closeKoiShushi = () => {
    disptchCTAClickObject('fidenza', 'Button', 'KoiShushi', 'Close', '');
    setKoiShushiActive(false);
  };

  const openParmaMenu = () => {
    disptchCTAClickObject('fidenza', 'Button', 'ParmaMenu', 'Open', '');
    setParmaMenuActive(true);
  };

  const closeParmaMenu = () => {
    disptchCTAClickObject('fidenza', 'Button', 'ParmaMenu', 'Close', '');
    setParmaMenuActive(false);
  };

  const openVenchi = () => {
    disptchCTAClickObject('fidenza', 'Button', 'Venchi', 'Open', '');
    setVenchiActive(true);
  };

  const closeVenchi = () => {
    disptchCTAClickObject('fidenza', 'Button', 'Venchi', 'Close', '');
    setVenchiActive(false);
  };

  const openVeroLattee = () => {
    disptchCTAClickObject('fidenza', 'Button', 'VeroLattee', 'Open', '');
    setVeroLatteActive(true);
  };

  const closeVeroLattee = () => {
    disptchCTAClickObject('fidenza', 'Button', 'VeroLattee', 'Close', '');
    setVeroLatteActive(false);
  };

  const openShopAndEarn = () => {
    disptchCTAClickObject('fidenza', 'Button', 'ShopAndEarn', 'Open', '');
    setShopEarnActive(true);
  };

  const closeShopAndEarn = () => {
    disptchCTAClickObject('fidenza', 'Button', 'ShopAndEarn', 'Close', '');
    setShopEarnActive(false);
  };

  const openFidenzaHfs = () => {
    disptchCTAClickObject('fidenza', 'Button', 'HandsFreeShopping', 'Open', '');
    setHfsActive(true);
  };

  const closeFidenzaHfs = () => {
    disptchCTAClickObject('fidenza', 'Button', 'HandsFreeShopping', 'Close', '');
    setHfsActive(false);
  };

  const closeVillageInfo = () => {
    setVillageInfoActive(false);
    disptchCTAClickObject('fidenza', 'Button', 'VillageInfo', 'close', '');
  };

  useEffect(() => {
    window.openVillageInfo = openVillageInfo;
    window.openPassport = openPassport;
    window.updateActiveScene = updateActiveScene;
    window.openGameReward = openGameReward;
    window.openArtGallery = openArtGallery;
    window.openArtFestival = openArtFestival;
    window.openArtOne = openArtOne;
    window.openArtTwo = openArtTwo;
    window.openArtThree = openArtThree;
    window.openArtFour = openArtFour;
    window.openFidenzaShoppingExpress = openFidenzaShoppingExpress;
    window.openFidenzaAttractions = openFidenzaAttractions;
    window.openFidenzaMember = openFidenzaMember;
    window.openFidenzaSfh = openFidenzaSfh;
    window.openFidenzaApartmentWelcome = openFidenzaApartmentWelcome;
    window.openFidenzaApartmentServices = openFidenzaApartmentServices;
    window.openFidenzaServices = openFidenzaServices;
    window.openDownloadApp = openDownloadApp;
    window.openSignorvino = openSignorvino;
    window.openBollicine = openBollicine;
    window.openCappuccino = openCappuccino;
    window.openFlowerBurger = openFlowerBurger;
    window.openKoiShushi = openKoiShushi;
    window.openParmaMenu = openParmaMenu;
    window.openVenchi = openVenchi;
    window.openFidenzaVeroLattee = openVeroLattee;
    window.openFidenzaPersonalShopping = openFidenzaPersonalShopping;
    window.openShopAndEarn = openShopAndEarn;
    window.openFidenzaHfs = openFidenzaHfs;
  }, []);

  return (
    <>
      {/* <LoadingScreen setLoadUI={() => setLoadUI(true)} /> */}
      {/* {loadUI && ( */}
      <>
        <Overlay
          closeAllUI={() => {
            setInstructionsActive(false);
          }}
          openFirstModal={() => setInstructionsActive(true)}
          activeScene={activeScene}
          setActiveScene={setActiveScene}
          togglePassport={() => {
            const cta_action: string = passportActive ? 'Open' : 'Close';
            disptchCTAClickObject('fidenza', 'Button', 'Passport', cta_action, '');
            setPassportActive(!passportActive);
          }}
          toggleInstructions={() => {
            const cta_action: string = instructionsActive ? 'Open' : 'Close';
            disptchCTAClickObject('fidenza', 'Button', 'Instructions', cta_action, '');
            setInstructionsActive(!instructionsActive);
          }}
          // toggleMap={() => {
          //   setMapActive(!mapActive);
          // }}
        />
        <Instructions active={instructionsActive} setActive={closeInstructions} />
        <InstructionsVillageInfo
          active={villageInfoActive}
          setActive={() => closeVillageInfo()}
          villageName={villageName}
        />
        <Passport active={passportActive} setActive={() => closePassport()} villageName={villageName} />
        <GameReward villageName="fidenza" active={gameRewardActive} setActive={() => closeGameReward()} />
        <FidenzaShoppingExpress active={shoppingExpressActive} setActive={() => closeFidenzaShoppingExpress()} />
        <FidenzaAttractions active={attractionsActive} setActive={() => closeFidenzaAttractions()} />
        <ArtGallery active={artGalleryActive} setActive={() => closeArtGallery()} />
        <ArtFestival active={artFestivalActive} setActive={() => closeArtFestival()} />
        <ArtOne active={artOneActive} setActive={() => closeArtOne()} />
        <ArtTwo active={artTwoActive} setActive={() => closeArtTwo()} />
        <ArtThree active={artThreeActive} setActive={() => closeArtThree()} />
        <ArtFour active={artFourActive} setActive={() => closeArtFour()} />
        <FidenzaMember active={memberActive} setActive={() => closeFidenzaMember()} />
        <FidenzaSfh active={sfhActive} setActive={() => closeFidenzaSfh()} />
        <PersonalShopping active={personalShoppingActive} setActive={() => closeFidenzaPersonalShopping()} />
        <FidenzaServices active={servicesActive} setActive={() => closeFidenzaServices()} />
        <DownloadApp active={downloadAppActive} setActive={() => closeDownloadApp()} />
        <Signorvino active={signoActive} setActive={() => closeSignorvino()} />
        <Bollicine active={bollicineActive} setActive={() => closeBollicine()} />
        <Capuccino active={capuccinoActive} setActive={() => closeCappuccino()} />
        <FlowerBurger active={flowerBurgerActive} setActive={() => closeFlowerBurger()} />
        <KoiShushi active={koiShushiActive} setActive={() => closeKoiShushi()} />
        <ParmaMenu active={parmaMenuActive} setActive={() => closeParmaMenu()} />
        <Venchi active={venchiActive} setActive={() => closeVenchi()} />
        <VeroLatte active={veroLatteActive} setActive={() => closeVeroLattee()} />
        <ShopAndEarn active={shopEarnActive} setActive={() => closeShopAndEarn()} />
        <HandsFreeShopping active={hfsActive} setActive={() => closeFidenzaHfs()} />
        <ApartmentWelcome active={apartmentWelcomeActive} setActive={() => closeFidenzaApartmentWelcome()} />
        <ApartmentServices active={apartmentServicesActive} setActive={() => closeFidenzaApartmentServices()} />
      </>
      {/* )} */}
    </>
  );
}

export default FidenzaApp;
